import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../utility';

const initialState = {
    token: null, // TODO switch back to null
    error: null,
    loading: false,
    user: {
        user: '',
        personal_code: '',
        key: '',
        first_name: '',
        last_name: '',
        is_admin: false,
        is_superuser: false,
        email: "",
        phone: "",
        faxes: [],
        user_type: {
            client_name: '',
            profession: '',
            user_type: ''
        },
        user_settings: {
            is_debt: false,
            language: 'ee',
            is_package_registration: false,
            is_sales_report: false,
            is_email_notification: false,
            is_push_notification: false
        },
        clients: [
            {
                name: '',
                active_client: false,
                is_valid_contract: false,
                is_unapproved_contract: false
            }
        ],
    },
    users: [],
    authType: null,
};

const registerStart = (state, action) => {
    return updateObject(state, {
        errorMessage: null,
        successMessage: null,
        loading: true
    })
};

const registerSuccess = (state, action) => {
    return updateObject(state, {
        successMessage: "User successfully registered!",
        loading: false
    })
};

const registerFail = (state, action) => {
    return updateObject(state, {
        errorMessage: action.error,
        loading: false
    })
};

const authStart = (state, action) => {
    return updateObject(state, {
        error: null,
        loading: true
    })
};

const authSuccess = (state, action) => {
    return updateObject(state, {
        token: action.token,
        error: null,
        loading: false
    })
};

const authFail = (state, action) => {
    return updateObject(state, {
        token: null,
        error: action.error,
        loading: false
    })
};

const logOut = (state, action) => {
    return updateObject(state, {
        token: null,
    })
};

const getUser = (state, action) => {
    if (!action.user) {
        return updateObject(state, {
            user: action.user,
        })
    }
    return updateObject(state, {
        user: {
            ...action.user,
            cert: action.user.cert || localStorage.getItem("cert"),
        },
        authType: localStorage.getItem("authType"),
        phoneNumberMID: localStorage.getItem("phoneNumberMID"),
    })
};


const auth = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.REGISTER_START:
            return registerStart(state, action);
        case actionTypes.REGISTER_SUCCESS:
            return registerSuccess(state, action);
        case actionTypes.REGISTER_FAIL:
            return registerFail(state, action);
        case actionTypes.AUTH_START:
            return authStart(state, action);
        case actionTypes.AUTH_SUCCESS:
            return authSuccess(state, action);
        case actionTypes.AUTH_FAIL:
            return authFail(state, action);
        case actionTypes.LOG_OUT:
            return logOut(state, action);
        case actionTypes.GET_AUTH_USER:
            return getUser(state, action);
        default:
            return state;
    }
};

export default auth;